import React from "react";
import { useSelector } from "react-redux";
import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import CustomButton from "../../../assets/components/CustomButton";
import HintImg from "../../../assets/images/joftPooch/HintImg.png";
import LoadingDialog from "../../../assets/containers/loadingDialog";

export default function StartMatchAlert({ show, startMatch, handleClose }) {
  const { loadingQuizReq } = useSelector(({ quiz }) => quiz);
  const modalContent = (
    <>
      <div className="w-100 text-center">
        <img src={HintImg} alt="awardIcon" className={classes.alertBanner} />
        <p className={classes.title}>شروع چالش</p>
        <div className={classes.dialogContent}>
          <p className="text-right">
            اگه وارد چالش شدی، زمان مشخصی داری و از دکمه برگشت نمیتونی استفاده
            کنی.
            <br /> آماده‌ای؟ 😃
          </p>
        </div>
        <div className="w-100 mt-4">
          {loadingQuizReq ? (
            <LoadingDialog
              className={"d-flex justify-content-center"}
              size={20}
            />
          ) : (
            <CustomButton
              clickHandler={startMatch}
              color={"primary"}
              shadow
              text={"شروع"}
            />
          )}
        </div>
      </div>
    </>
  );
  return (
    <CustomModal
      open={show}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={modalContent}
    />
  );
}
